<template>
    <div>
        <div>
            <Spin size="large" fix v-if="true"></Spin>
        </div>
    </div>

</template>

<script>
    import store from '@/store/index.js';
    import {lang} from "@/utils/language.js";
    import {getQuerys} from '@/utils/common.js';
    import {openLogin} from '@/utils/net.js';
    export default {
        name: "OpenLogin",
        store,
        data() {
            return {
                lang: lang,
                stateLang: '',
                query:{},
                extra:{},
            }
        },
        mounted() {
            store.commit('removeUserInfo');
            store.commit('removeScope');
            store.commit('removeIsTip');
            store.commit('removeMaxWidth');
            store.commit('removeHideModule');
            var url = window.location.href;
            var obj = getQuerys(url);
            if("partner" in obj){
                this.query.partner = obj.partner;
            }
            if("puid" in obj){
                this.query.puid = obj.puid;
            }
            if("ts" in obj){
                this.query.ts = obj.ts;
            }
            if("sign" in obj){
                this.query.sign = obj.sign;
            }
            this.extra = obj;
            this.openLogin();
        },
        methods:{
            openLogin: function () {
                let that = this;
                openLogin({
                    context: that,
                    url: '/partner/open/login',
                    params: that.query,
                    onCallBack: function (retMap) {
                        var user = {};
                        user.userId = retMap.userId;
                        user.accessToken = retMap.accessToken;
                        user.userName = retMap.userName;
                        user.adminRole = retMap.userRole;
                        user.isSvip = retMap.isSvip;
                        store.commit("setUserInfo", user);
                        store.commit("setIsTip", retMap.isTp);
                        if ("maxWidth" in that.extra) {
                            store.commit("setMaxWidth", that.extra.maxWidth);
                        }
                        if ("hideModule" in that.extra) {
                            var arr = that.extra.hideModule.split(",");
                            store.commit("setHideModule", arr);
                        }else{
                            store.commit("setHideModule", []);
                        }
                        if ("callBack" in that.extra) {
                            store.commit("setCallBack", that.extra.callBack);
                        }
                        that.$router.push('/single/Home');
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                    }
                })
            }
        },
        computed:{
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            },
        }
    }
</script>

<style scoped>

</style>
